module.exports = __webpack_public_path__ + "static/media/S (72).6c92d4c3.jpg";